import React from "react";
import { Box, Button, Container, Heading, Text, VStack } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import { NavbarWithCallToAction } from "../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { HowItWorksStepCards } from "./HowItWorksSteps";

/**
 * How it works — rebuilt to Sam Manger's website feedback (27 Jul 2026): keep the title and
 * subheading, four steps in his words (HowItWorksSteps.tsx, shared with the homepage), and delete
 * the rest — the 6-week timeline and "what you'll achieve" promised outcomes we can't guarantee.
 * Dark, like the homepage.
 */
const HowItWorks = () => (
    <Box bg="#000000" minHeight="100vh" color="white">
        <NavbarWithCallToAction />

        <Container maxW="1400px" py={{ base: 12, md: 20 }}>
            <VStack spacing={{ base: 10, md: 14 }}>
                <VStack spacing={5} textAlign="center" maxW="800px">
                    <Text fontSize="sm" textTransform="uppercase" letterSpacing="0.25em" color="whiteAlpha.600">
                        How it works
                    </Text>
                    <Heading as="h1" fontSize={{ base: "4xl", md: "6xl" }} fontWeight="500" letterSpacing="-0.02em" lineHeight="1.1">
                        Everything you need to prepare for surgery, in one simple program.
                    </Heading>
                    <Text fontSize={{ base: "lg", md: "xl" }} color="whiteAlpha.800" lineHeight="1.7">
                        Four steps, at your own pace, alongside your own healthcare team.
                    </Text>
                </VStack>

                <HowItWorksStepCards />

                <VStack spacing={5} textAlign="center" pt={{ base: 4, md: 8 }}>
                    <Heading as="h2" fontSize={{ base: "2xl", md: "4xl" }} fontWeight="500">
                        Ready to get SurgReady?
                    </Heading>
                    <Button
                        as={RouterLink}
                        to="/pricing"
                        size="lg"
                        minH="56px"
                        px={10}
                        borderRadius="full"
                        bg="white"
                        color="black"
                        _hover={{ bg: "whiteAlpha.900", transform: "translateY(-2px)" }}
                        rightIcon={<ChevronRightIcon />}
                    >
                        Get started
                    </Button>
                </VStack>
            </VStack>
        </Container>

        <FooterWithFourColumns />
    </Box>
);

export default HowItWorks;
